module.exports = __webpack_public_path__ + "img/bpce.21e6b284.jpg";